import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SelectedImagesCounter } from '../components/SelectedImagesCounter';
import { IProjectDetailsImagesStore } from '../projectDetailsImages.store';

export const SelectedImagesCounterContainer = observer((): ReactElement => {
  const { selectionMode, toggledImages, imagesPaging } = useInjection(IProjectDetailsImagesStore.$);
  const count = selectionMode === 'Select' ? toggledImages.length : imagesPaging.unlockedImagesCount - toggledImages.length;

  return <SelectedImagesCounter count={count} />;
});
